import { useFramework, useMaxZoom, useMinZoom, useScale } from '@/framework';
import type { StageToolbar } from '../../stage-toolbar';

export const useScaleController = (toolbar: StageToolbar) => {
    const framework = useFramework();
    const scale = useScale();
    const min = useMinZoom();
    const max = useMaxZoom();
    const canvas = framework.service.edgelessCanvas;

    return {
        framework,
        scale,
        min,
        max,
        zoomIn() {
            canvas.zoomIn();
            toolbar.emitAction({ type: 'scale-adjust', action: 'zoom-in' });
        },
        zoomOut() {
            canvas.zoomOut();
            toolbar.emitAction({ type: 'scale-adjust', action: 'zoom-out' });
        },
        setScale(value: number) {
            canvas.setIsAutoScale(false);
            canvas.setZoom(value);
            toolbar.emitAction({ type: 'scale-adjust', action: 'set-scale' });
        },
        enableAutoScale() {
            canvas.setIsAutoScale(true);
            toolbar.emitAction({ type: 'scale-adjust', action: 'set-scale' });
        },
        fitViewport() {
            canvas.showAllObjects();
            toolbar.emitAction({ type: 'fit-viewport' });
        },
    };
};
